import styled from 'styled-components';
import { vars } from '../../theme';
export const ResizableContainer = styled.div<{
    currentSize: any;
    containerWidth: number;
    isVisible: any;
    // When touch-action is disabled we can't scroll in mobile when finger is on image
    // We do want it to be disabled when resizing so that the touch actions don't
    // mess up the resizing. I tried using isResizing as the flag here, but it caused
    // issues in resizing in mobile
    disableTouchAction: boolean;
}>`
    user-select: none;
    width: ${props =>
        props.currentSize ? `${props.currentSize.width}px` : 'auto'};
    max-width: ${props => `${props.containerWidth}px`};
    opacity: ${props => (props.isVisible ? 1 : 0)};
    ${props => props.disableTouchAction && 'touch-action: none;'}
`;

export const Container = styled.div`
    display: inline-block;
    position: relative;
`;

export const Point = styled.div<{
    verticalPosition: string;
    horizontalPosition: string;
}>`
    background-color: ${vars.colors.base.accent};
    width: 10px;
    height: 10px;
    border-radius: ${vars.radius.full};
    position: absolute;
    top: ${props => (props.verticalPosition === 'top' ? '-3px' : '')};
    bottom: ${props => (props.verticalPosition === 'bottom' ? '-3px' : '')};
    left: ${props => (props.horizontalPosition === 'left' ? '-3px' : '')};
    right: ${props => (props.horizontalPosition === 'right' ? '-3px' : '')};
    z-index: 10000;
`;
